import useAuth from 'Modules/firebase/use-auth';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ExistingOrgDescription = (): JSX.Element => {
    const { t } = useTranslation();
    const { user } = useAuth();

    return (
        <Stack spacing={5}>
            <Typography variant="body">
                {t('ExistingOrg.Content.Description', {
                    name: user?.given_name,
                })}
            </Typography>
            <Typography variant="body">
                {t('ExistingOrg.Content.SecondDescription')}
            </Typography>
            <Typography variant="body">
                {t('ExistingOrg.Content.ThirdDescription')}
            </Typography>
        </Stack>
    );
};

export default ExistingOrgDescription;
